import { type InputHTMLAttributes } from 'react';

interface InputPropsType extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  isAsterisk?: boolean;
}

export default function Input({ id, label, className, isAsterisk, ...props }: InputPropsType) {
  return (
    <div className="flex flex-col">
      {label && (
        <label className="pb-9px pl-[9px] text-[13px] text-[#4D4840]" htmlFor={id}>
          {label}
          {isAsterisk && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}
      <input
        id={id}
        className={`rounded-lg border-t-2 border-t-[#B2B2B2] bg-white py-[14px] pl-[9px] text-[13px] text-[#4D4840] ${className}`}
        {...props}
      />
    </div>
  );
}
